module.exports = __webpack_public_path__ + "fa354581d39a1eb0a24da01fcb1515f3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/popsicle.png
// module id = 2097
// module chunks = 0